export enum ModalType {
  UseOrionManagementStyleModal = 'UseOrionManagementStyleModal',
  UseAssets = 'UseAssets',
}
